import React from 'react';
import FileUploadVendors from '../components/amenities/FileUploadAmenities';

const AmenitiesData = () => {
  return (
    <div className="space-y-5">
      <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-gray-900">Amenities</h1>

      <FileUploadVendors />
    </div>
  );
};

export default AmenitiesData;
